<template>
  <div class="vx-row">
    <vx-card :title="$t('UsersTitle') + ': ' + (totalCount != null ? totalCount : '')">
      <slot name="header">
        <div class="vx-col"></div>
        <div class="vx-col">
        </div>
      </slot>
      
      <!-- Tab Navigation -->
      <div class="mb-4">
        <vs-tabs>
          <vs-tab :label="$t('UsersTitle')" @click="activeTab = 'users'">
            <div slot="title">
              <vs-icon icon="people" size="small"></vs-icon>
              <span>{{ $t('UsersTitle') }}</span>
            </div>
          </vs-tab>
          <vs-tab :label="$t('Invitations')" @click="activeTab = 'invitations'">
            <div slot="title">
              <vs-icon icon="mail" size="small"></vs-icon>
              <span>{{ $t('Invitations') }}</span>
            </div>
          </vs-tab>
          <vs-tab :label="$t('Suggestions')" @click="activeTab = 'suggestions'">
            <div slot="title">
              <vs-icon icon="lightbulb" size="small"></vs-icon>
              <span>{{ $t('Suggestions') }}</span>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>

      <!-- Tab Content -->
      <div v-if="activeTab === 'users'">
        <slot name="list"> 
          <UserList :totalCount="totalCount" :users="userCollection" @SearchNeeeded="LoadUsers"></UserList>
        </slot>
      </div>
      
      <div v-if="activeTab === 'invitations'">
        <InvitationList @invite-user="showInviteModal = true"></InvitationList>
      </div>
      
      <div v-if="activeTab === 'suggestions'">
        <SuggestionsList @invite-user="handleInviteUser"></SuggestionsList>
      </div>
      
      <slot name="footer"></slot>
    </vx-card>

    <!-- Invite User Modal -->
    <InviteUserModal 
      :active.sync="showInviteModal"
      :prefilled-email.sync="prefilledEmail"
      @update:active="showInviteModal = $event">
    </InviteUserModal>
  </div>
</template>
<script>

import UserList from "@/views/components/extra-components/users/UserList.vue";
import InviteUserModal from "@/views/components/extra-components/users/InviteUserModal.vue";
import InvitationList from "@/views/components/extra-components/users/InvitationList.vue";
import SuggestionsList from "@/views/components/extra-components/users/SuggestionsList.vue";
import VxCard from "../../../components/vx-card/VxCard.vue";
import DataService from "@/data/dataService.js";
import TCVelikClient from '@/TCVelikClient/TCVelikClient';

export default {
  data(){
    return {
      userCollection: [],
      totalCount: null,
      showInviteModal: false,
      activeTab: 'users',
      prefilledEmail: null
    }
  },
  props: ["users"],
  components: {
    UserList,
    InviteUserModal,
    InvitationList,
    SuggestionsList,
    VxCard,
  },
  mounted(){
    this.LoadUsers();
    //this.LoadRoles();
  },

    methods: {
      LoadUsers(skip, take, search, sortOrder, sortType) {
        if (!take || take < 1)
          take = 100;

        if (sortOrder == undefined || sortOrder === "")
        {
          sortOrder = "desc"
        }

        if (sortType == undefined || sortType === "")
        {
          sortType = "lld"
        }

        var instance = this;
        const query = `
                 query Users($skip: Int, $take: Int, $search: String,$sortType:String,$sortOrder:String!) {
                    users(skip: $skip, take: $take, search: $search,sortType:$sortType,sortOrder:$sortOrder) {
                        totalCount,
                        result{
                          avatarUrl
                          firstName
                          lastName
                          id
                          userName,
                          provider,
                          lastLoginDate
                          created
                          email
                          phoneNumber
                          phoneNumberConfirmed
                          apiKey
                          roles {
                              id
                              name
                              normalizedName
                              concurrencyStamp
                          }
                        }
                    }
                }
                `;

        const req = {
          query,
          variables: {
            skip: skip,
            take: take,
            search: search,
            sortType: sortType,
            sortOrder: sortOrder
          }
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {

            instance.$set(instance, "userCollection", response.data.data.users.result);
            instance.$set(instance, "totalCount", response.data.data.users.totalCount);
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ErrorFetchingUsers'));
          }
        });

      },
      LoadRoles(skip, take, search) {
        if (!take || take < 1)
          take = 100;

        var instance = this;
        const query = `
           query Roles($skip: Int, $take: Int, $search: String) {
              roles(skip: $skip, take: $take, search: $search) {
                  totalCount,
                  result{
                    id,
                    name
                  }
              }
          }
          `;

        const req = {
          query,
          variables: {
            skip: 0,
            take: 3000,
            search: search
          }
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ErrorFetchingUsers'));
          }
        });
      },
      
      handleInviteUser(email) {
        this.prefilledEmail = email;
        this.showInviteModal = true;
      },
    }
};
</script>
